import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';
import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';
import BillingReports from '../BillingReports';

export const BillingReportsRoutes: RouteObject[] = [
  {
    path: 'billing-reports',
    element: (
      <Authorize permission={BUSINESS_ROLE_GROUPS.billing} fallback={<ErrorPage code={403} />}>
        <BillingReports />
      </Authorize>
    ),
  },
];
